<template>
  <crud-template
      @deleteItem="deleteItem"
      @dialogClosed="clearForm"
      ref="formTemplate" :editedItem.sync="formData">
    <template #default="{editItemHandler}">
      <div class="d-flex justify-space-between mb-3">
        <custom-autocomplete
            v-model="options.mko_id"
            :items="mkos"
            @input="() => {options.page = 1; onInputMko()}"
            clearable
            label="МКО"
            hide-details
        ></custom-autocomplete>
        <v-btn @click="editItemHandler('create')" color="primary">
          <v-icon class="mr-2" small>fas fa-plus</v-icon>
          Добавить новый
        </v-btn>
      </div>
      <v-data-table
          disable-pagination
          :headers="headers"
          hide-default-footer
          :items="items">
        <template #item.percent="{item}">{{ item.percent }}%</template>
        <template #item.min_amount="{item}">{{ item.min_amount|money }}</template>
        <template #item.max_amount="{item}">{{ item.max_amount|money }}</template>
        <template #item.action="{item}">
          <div class="action-btn-wrap">
            <v-btn @click="editItemHandler('edit', item)" class="action-btn" color="warning">
              <v-icon x-small>fas fa-pencil-alt</v-icon>
            </v-btn>
            <v-btn @click="editItemHandler('delete', item)" class="action-btn" color="error">
              <v-icon x-small>fas fa-trash</v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
      <v-pagination
          @input="onInputMko"
          v-if="lastPage > 1"
          v-model="options.page"
          :length="lastPage"
      ></v-pagination>
    </template>

    <template #form-content="{isUpdate, loading}">
      <validation-observer ref="formObs" v-slot="{handleSubmit}">
        <form @submit.prevent="handleSubmit(() => save(isUpdate))">
          <v-row class="form-dialog-modal">
            <v-col sm="6" cols="12">
              <custom-input-text
                  name="Название"
                  label="Название"
                  v-model="formData.name"
                  rules="required"
              ></custom-input-text>
            </v-col>
            <v-col sm="6" cols="12">
              <custom-select
                  :items="TARIFF_TYPES"
                  v-model="formData.type"
                  item-text="text"
                  item-value="value"
                  name="Тип"
                  label="Тип"
                  rules="required"
              ></custom-select>
            </v-col>
            <v-col sm="6" cols="12">
              <validation-provider name="Процент" vid="percent" v-slot="{errors}" rules="required">
                <v-text-field
                    outlined
                    :error-messages="errors[0]"
                    dense
                    type="number"
                    min="0"
                    max="90"
                    step="0.001"
                    name="Процент"
                    label="Процент (мес.)"
                    v-model="formData.percent"
                ></v-text-field>
              </validation-provider>
            </v-col>
            <v-col sm="6" cols="12">
              <custom-input-text
                  only="number"
                  label="Льготный период (мес.)"
                  vid="passive_period"
                  v-model="formData.passive_period"
                  rules="required"
              ></custom-input-text>
            </v-col>
            <v-col sm="6" cols="12">
              <money-input
                  label="Минимальная сумма"
                  vid="min_amount"
                  v-model="formData.min_amount"/>
            </v-col>
            <v-col sm="6" cols="12">
              <money-input
                  label="Максимальная сумма"
                  vid="max_amount"
                  v-model="formData.max_amount"
                  rules="required"
              ></money-input>
            </v-col>
            <v-col sm="6" cols="12">
              <custom-input-text
                  type="number"
                  min="0"
                  vid="min_period"
                  label="Минимальный срок (мес.)"
                  v-model="formData.min_period"
              ></custom-input-text>
            </v-col>
            <v-col sm="6" cols="12">
              <custom-input-text
                  min="0"
                  label="Максимальный срок (мес.)"
                  type="number"
                  vid="max_period"
                  v-model="formData.max_period"
                  rules="required"
              ></custom-input-text>
            </v-col>
            <v-col sm="6" cols="12" v-if="$store.getters.isUserSuperAdmin">
              <custom-autocomplete
                  :items="mkos"
                  rules="required"
                  label="МКО"
                  v-model="formData.mko_id"
              ></custom-autocomplete>
            </v-col>
            <v-col sm="6" cols="12">
              <v-switch
                  class="mt-0"
                  dense
                  :true-value="10"
                  :false-value="0"
                  v-model="formData.status"
                  label="Статус"
              ></v-switch>
            </v-col>
            <v-col cols="12">
              <v-btn width="100%" color="primary" type="submit" :loading="loading">Сохранить</v-btn>
            </v-col>
          </v-row>

        </form>
      </validation-observer>
    </template>
  </crud-template>
</template>

<script>
import crudTemplate from "@/components/ui/crud/template";
import {messages, TARIFF_TYPES} from '@/utils/constants'
import MoneyInput from "@/plugins/vuetify/components/MoneyInput";
import {getObjectValuesByKey, removerSpace, shallowEqual} from "@/utils/pureFunctions";
import {mapGetters} from 'vuex'

export default {
  data() {
    return {
      mkos: [],
      formData: {
        type: null,
        name: null,
        percent: null,
        passive_period: null,
        min_period: null,
        max_period: null,
        min_amount: null,
        max_amount: null,
        status: 10
      },
      headers: [
        {
          text: 'Название',
          value: 'name'
        },
        {
          text: 'Тип',
          value: 'type'
        },
        {
          text: 'Процент',
          value: 'percent'
        },
        {
          text: 'Льготный период (мес.)',
          value: 'passive_period'
        },
        {
          text: 'Минимальная сумма',
          value: 'min_amount'
        },
        {
          text: 'Максимальная сумма ',
          value: 'max_amount'
        },
        {
          text: ' Минимальный срок (мес.)',
          value: 'min_period'
        },
        {
          text: ' Максимальный срок (мес.)',
          value: 'max_period'
        },
        {
          text: 'Действие',
          value: 'action'
        }
      ],
      items: [],
      TARIFF_TYPES,
      lastPage: 0,
      options: {
        page: 1,
        mko_id: null
      }
    }
  },
  methods: {
    async getMkos() {
      try {
        const {data: {data}} = await this.$http.get('admin/mko')
        this.mkos = data
      } catch (e) {
        this.$setResponseError({error: e})
      }
    },
    async deleteItem(item) {
      this.$showLoading()
      try {
        await this.$http.delete(`admin/tariffs/${item.id}`)
        this.items = this.items.filter(tariff => {
          return tariff.id !== item.id
        })
        this.$setSuccess({text: messages.onDelete})
      } catch (e) {
        this.$setResponseError({error: e})
      } finally {
        this.$clearLoading()
      }
    },
    async clearForm() {
      const {formObs} = this.$refs
      if (formObs) formObs.reset()
    },
    async getItems() {
      try {
        const url = this.isUserSuperAdmin ? 'admin/tariffs/all' : 'admin/tariffs'
        const {data: {data, links: {last_page}}} = await this.$http.get(url, {params: this.options})
        this.lastPage = last_page
        this.items = data
      } catch (e) {
        this.$setResponseError({error: e})
      }

    },
    async save(isUpdate) {
      const {formTemplate} = this.$refs
      if (formTemplate) formTemplate.$showFormLoading()
      try {
        if (isUpdate) {
          await this.update()
        } else {
          await this.create()
        }
        formTemplate.$clearFormLoading()
        if (formTemplate) {
          formTemplate.closeFormDialog()
        }
        this.$setSuccess({text: messages.onSave})

      } catch (e) {
        this.$setResponseError({error: e})
        this.$setFormError({error: e, obs: this.$refs.formObs})
        formTemplate.$clearFormLoading()

      }
    },
    async create() {
      try {
        let formData = {...this.formData}
        if (!formData.min_amount) formData.min_amount = 0
        if (!formData.min_period) formData.min_period = 0
        if (!formData.passive_period) formData.passive_period = 0
        if (formData.min_amount) formData.min_amount = removerSpace(formData.min_amount)
        if (formData.max_amount) formData.max_amount = removerSpace(formData.max_amount)
        const {data: {data}} = await this.$http.post("admin/tariffs", formData)
        this.items.push(data)
      } catch (e) {
        return Promise.reject(e)
      }

    },
    async update() {
      const {id} = this.formData
      try {
        let formData = {...this.formData}
        if (!formData.min_amount) formData.min_amount = 0
        if (!formData.min_period) formData.min_period = 0
        if (!formData.passive_period) formData.passive_period = 0
        if (formData.min_amount) formData.min_amount = removerSpace(formData.min_amount)
        if (formData.max_amount) formData.max_amount = removerSpace(formData.max_amount)
        await this.$http.put(`admin/tariffs/${id}`, formData)
        await this.getItems()
      } catch (e) {
        return Promise.reject(e)
      }

    },
    async onInputMko(val) {
      const {query} = this.$route
      let options = {...this.options, page: `${this.options.page}`}
      if (!shallowEqual(options, query)) {
        try {
          await this.$router.replace({query: options})
        } catch (e) {
          console.error(e)
        }
      }
      this.$showLoading()
      await this.getItems()
      this.$clearLoading()
    }
  },
  computed: {
    ...mapGetters(['isUserSuperAdmin'])
  },
  components: {MoneyInput, crudTemplate},
  async created() {
    let options = getObjectValuesByKey(this.options, this.$route.query)
    if (typeof options.page === 'string' && !isNaN(options.page)) options.page = +options.page
    if (typeof options.mko_id === 'string' && !isNaN(options.mko_id)) options.mko_id = +options.mko_id
    this.options = options
    this.$showLoading()
    await this.getItems()
    await this.getMkos()
    this.$clearLoading()
  }
}
</script>
